import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../fragments/pageInfo.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AllCarsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  before?: Types.InputMaybe<Types.Scalars['String']>;
  after?: Types.InputMaybe<Types.Scalars['String']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  number?: Types.InputMaybe<Types.Scalars['String']>;
  customer?: Types.InputMaybe<Types.Scalars['Float']>;
  text?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type AllCarsQuery = { __typename?: 'Query', allCars?: { __typename?: 'CarNodeConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'CarNodeEdge', cursor: string, node?: { __typename?: 'CarNode', id: string, number: string, color?: string | null, carSubModel: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', name: string, localName?: string | null } } } | null } | null> } | null };


export const AllCarsDocument = gql`
    query AllCars($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $number: String, $customer: Float, $text: String) {
  allCars(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    number: $number
    customer: $customer
    text: $text
  ) {
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        id
        number
        color
        carSubModel {
          id
          name
          localName
          carModel {
            name
            localName
          }
        }
      }
      cursor
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useAllCarsQuery__
 *
 * To run a query within a React component, call `useAllCarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCarsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      number: // value for 'number'
 *      customer: // value for 'customer'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useAllCarsQuery(baseOptions?: Apollo.QueryHookOptions<AllCarsQuery, AllCarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCarsQuery, AllCarsQueryVariables>(AllCarsDocument, options);
      }
export function useAllCarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCarsQuery, AllCarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCarsQuery, AllCarsQueryVariables>(AllCarsDocument, options);
        }
export type AllCarsQueryHookResult = ReturnType<typeof useAllCarsQuery>;
export type AllCarsLazyQueryHookResult = ReturnType<typeof useAllCarsLazyQuery>;
export type AllCarsQueryResult = Apollo.QueryResult<AllCarsQuery, AllCarsQueryVariables>;